import { Component } from '@angular/core';
import {  IonicModule, NavController, NavParams, Platform } from '@ionic/angular';
import {UserManagerProvider} from '../../providers/user-manager/user-manager';
import { TranslateService } from '@ngx-translate/core';
import { CompHeaderComponent } from '../../components/comp-header/comp-header';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LoggerService } from '../services/logger.service';



@Component({
  selector: 'page-support',
  templateUrl: 'support.html',
  styleUrls: ['support.scss'],
  
  standalone: true,
  imports: [
    CompHeaderComponent, IonicModule, CommonModule, TranslateModule, FormsModule, CommonModule]
})
export class SupportPage {
  public device: string;
  information: string;
  public defaultLang: string;
  constructor(public navCtrl: NavController,
              public platform: Platform,
              public translateService: TranslateService,
              public userManager: UserManagerProvider,
              public logger: LoggerService) {

         this.defaultLang = this.translateService.currentLang;
         if (this.defaultLang) {
           this.logger.debug(this.defaultLang);
         }
         if (this.platform.is('ios')) {
          this.device = 'ios';
        } else if (this.platform.is('android')) {
          this.device = 'android';
        } else {
          this.device ='unkown';
        }
  }
  isPersian() {
    this.defaultLang = this.translateService.currentLang;
    if (this.defaultLang === 'fa') {
      return false;
    } else {
      return true;
    }
  }
  ionViewDidLoad() {
    this.information = this.userManager.user.userID + '-' + this.device;
  }
toshow() {
  this.logger.debug(this.defaultLang);
}
}
